import React from 'react';
import { requestSourceFromUrl } from '../helper';
import RequestPanelContainerContent from './RequestPanelContainerContent';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const RequestPanelNewContainer = ({
  category,
  className,
  code,
  compact,
  onChange,
  url,
}) => {
  const { readStatus } = Selectors.useRequestPanelContainer({ category, code });
  const { requestSourceType, requestSourceCode } = requestSourceFromUrl(url);
  Fetch.useNewRequestFromSource({
    category, code, requestSourceType, requestSourceCode,
  }, readStatus);

  return (
    <RequestPanelContainerContent
      category={category}
      className={className}
      code={code}
      compact={compact}
      isNew
      onChange={onChange}
      url={url}
    />
  );
};

export default RequestPanelNewContainer;
